import { FORBIDDEN_EXACT, FORBIDDEN_PARTIAL } from 'utils/usernameForbidden';

export const exactForbidden = FORBIDDEN_EXACT;

export const partialForbiddenPattern = new RegExp(FORBIDDEN_PARTIAL.join('|'), 'i');
